var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Select, Store, Actions, ofActionCompleted } from '@ngxs/store';
import { AuthState } from '../../state/auth/auth.state';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { GetUserProfile, Logout, LogoutSuccess, LogoutFailure, SignUpFailure, LoginFailure } from '../../state/auth/auth.actions';
import { LoginArt } from '../../models/login-art.enum';
import * as _ from 'lodash';
import { MatSnackBar } from '@angular/material';
var LoginMasterComponent = /** @class */ (function () {
    function LoginMasterComponent(router, activatedRoute, store, actions, snackbar) {
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.store = store;
        this.actions = actions;
        this.snackbar = snackbar;
        this.ngUnsubscribe = new Subject();
    }
    LoginMasterComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Automatically log users out when they come to this page, primarily so we can 
        // ensure things like group invitations will work.
        this.actions.pipe(ofActionCompleted(LogoutSuccess, LogoutFailure), takeUntil(this.ngUnsubscribe)).subscribe(function () {
            _this.initLoginListeners();
        });
        this.store.dispatch(new Logout());
        this.activatedRoute.url.subscribe(function (url) {
            _this.loginArt = _.get(_this.activatedRoute, 'snapshot.firstChild.data.loginArt') || LoginArt.login;
        });
        this.actions.pipe(ofActionCompleted(SignUpFailure, LoginFailure), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            // This is why it's nested:
            // <stateFailure>.<calledAction>.<HttpErrorResponse>.<Error of HttpErrorResponse>.<Custom Error Object>.<Message>
            var message = _.get(action, 'action.error.error.error.message') || 'There was an error logging in.';
            _this.handleFailure(message);
        });
    };
    LoginMasterComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    LoginMasterComponent.prototype.initLoginListeners = function () {
        var _this = this;
        this.loggedIn$.pipe(filter(function (loggedIn) { return loggedIn; }), takeUntil(this.ngUnsubscribe)).subscribe(function (loggedIn) {
            _this.store.dispatch(new GetUserProfile());
        });
        this.userProfile$.pipe(filter(function (profile) { return profile != null; }), takeUntil(this.ngUnsubscribe)).subscribe(function (profile) {
            _this.redirect();
        });
    };
    LoginMasterComponent.prototype.redirect = function () {
        var returnUrl = this.activatedRoute.snapshot.queryParamMap.get('returnUrl');
        if (returnUrl) {
            this.router.navigateByUrl(returnUrl);
        }
        else {
            this.router.navigate(['/dashboard']);
        }
    };
    LoginMasterComponent.prototype.handleFailure = function (message) {
        this.snackbar.open(message, '', { duration: 10000 });
    };
    __decorate([
        Select(AuthState.getLoggedIn),
        __metadata("design:type", Observable)
    ], LoginMasterComponent.prototype, "loggedIn$", void 0);
    __decorate([
        Select(AuthState.getUserProfile),
        __metadata("design:type", Observable)
    ], LoginMasterComponent.prototype, "userProfile$", void 0);
    return LoginMasterComponent;
}());
export { LoginMasterComponent };
